import { type FC } from "react";

import { OptionCard } from "@/shared/components/ui/OptionCard";
import { FieldError } from "@/shared/components/ui/FieldError";
import { RadioGroup } from "@/shared/components/ui/radio-group";
import type { FlowQuestion } from "@/shared/constants/flowTypes";

interface MultipleChoiceProps {
  question: FlowQuestion;
  value: string | undefined;
  onChange: (value: string) => void;
  errorMessage?: string;
  textInputValues?: Record<string, string>;
  onTextInputChange?: (optionValue: string, text: string) => void;
}

export const MultipleChoice: FC<MultipleChoiceProps> = ({
  question,
  value,
  onChange,
  errorMessage,
  textInputValues,
  onTextInputChange,
}) => {
  if (!question.options) return null;

  return (
    <div className="flex flex-col gap-2">
      <RadioGroup
        value={value}
        onValueChange={onChange}
        className="flex flex-col gap-3"
      >
        {question.options.map((option) => (
          <OptionCard
            key={option.value}
            label={option.label}
            icon={option.icon}
            selected={value === option.value}
            onClick={() => onChange(option.value)}
            variant="radio"
            value={option.value}
            hasTextInput={option.hasTextInput}
            textInputPlaceholder={option.textInputPlaceholder}
            textInputValue={textInputValues?.[option.value]}
            onTextInputChange={
              option.hasTextInput
                ? (text) => onTextInputChange?.(option.value, text)
                : undefined
            }
          />
        ))}
      </RadioGroup>
      <FieldError message={errorMessage} />
    </div>
  );
};
